<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { RouterLink } from "vue-router";

import { useFaqListTracking } from "@/composables";

import LeFaqItem from "./LeFaqItem.vue";

const { t } = useI18n();

const { trackFaqItemClick } = useFaqListTracking("private");
</script>

<template>
  <LeFaqItem @click="trackFaqItemClick($event, 0)">
    <template #button>
      {{ t("le-support-view.faq.private.question1.q") }}
    </template>

    <i18n-t tag="span" keypath="le-support-view.faq.private.question1.a">
      <template #link>
        <a href="/reset-password" class="link">
          {{ t("le-support-view.faq.private.question1.link") }}
        </a>
      </template>
    </i18n-t>
  </LeFaqItem>
  <LeFaqItem @click="trackFaqItemClick($event, 1)">
    <template #button>
      {{ t("le-support-view.faq.private.question2.q") }}
    </template>
    {{ t("le-support-view.faq.private.question2.a") }}
  </LeFaqItem>
  <LeFaqItem @click="trackFaqItemClick($event, 2)">
    <template #button>
      {{ t("le-support-view.faq.private.question3.q") }}
    </template>
    <i18n-t tag="span" keypath="le-support-view.faq.private.question3.a">
      <template #link>
        <RouterLink :to="{ name: 'subscription' }" class="link">
          {{ t("le-support-view.faq.private.question3.link") }}
        </RouterLink>
      </template>
    </i18n-t>
  </LeFaqItem>
  <LeFaqItem @click="trackFaqItemClick($event, 3)">
    <template #button>
      {{ t("le-support-view.faq.private.question4.q") }}
    </template>
    {{ t("le-support-view.faq.private.question4.a") }}
  </LeFaqItem>
  <LeFaqItem @click="trackFaqItemClick($event, 4)">
    <template #button>
      {{ t("le-support-view.faq.private.question5.q") }}
    </template>
    <i18n-t tag="span" keypath="le-support-view.faq.private.question5.a">
      <template #link>
        <RouterLink :to="{ name: 'subscription' }" class="link">
          {{ t("le-support-view.faq.private.question5.link") }}
        </RouterLink>
      </template>
    </i18n-t>
  </LeFaqItem>
  <LeFaqItem @click="trackFaqItemClick($event, 5)">
    <template #button>
      {{ t("le-support-view.faq.private.question6.q") }}
    </template>
    {{ t("le-support-view.faq.private.question6.a") }}
  </LeFaqItem>
  <LeFaqItem @click="trackFaqItemClick($event, 6)">
    <template #button>
      {{ t("le-support-view.faq.private.question7.q") }}
    </template>
    {{ t("le-support-view.faq.private.question7.a") }}
  </LeFaqItem>
  <LeFaqItem @click="trackFaqItemClick($event, 7)">
    <template #button>
      {{ t("le-support-view.faq.private.question8.q") }}
    </template>
    {{ t("le-support-view.faq.private.question8.a") }}
  </LeFaqItem>
  <LeFaqItem @click="trackFaqItemClick($event, 8)">
    <template #button>
      {{ t("le-support-view.faq.private.question9.q") }}
    </template>
    {{ t("le-support-view.faq.private.question9.a") }}
  </LeFaqItem>
  <LeFaqItem @click="trackFaqItemClick($event, 9)">
    <template #button>
      {{ t("le-support-view.faq.private.question10.q") }}
    </template>
    {{ t("le-support-view.faq.private.question10.a") }}
  </LeFaqItem>
  <LeFaqItem @click="trackFaqItemClick($event, 10)">
    <template #button>
      {{ t("le-support-view.faq.private.question11.q") }}
    </template>
    <i18n-t tag="span" keypath="le-support-view.faq.private.question11.a">
      <template #link>
        <a href="/download#desktop-app" class="link">
          {{ t("le-support-view.faq.private.question11.link") }}
        </a>
      </template>
    </i18n-t>
  </LeFaqItem>
  <LeFaqItem @click="trackFaqItemClick($event, 11)">
    <template #button>
      {{ t("le-support-view.faq.private.question12.q") }}
    </template>
    {{ t("le-support-view.faq.private.question12.a") }}
  </LeFaqItem>
</template>

<style scoped lang="less">
@import "@dsk/styles/all";

.link {
  .link();
  .body-text("m");
}
</style>
